import React from 'react';
import { Video, Phone, MessageSquare, Star } from 'lucide-react';
export function LiveClasses() {
  return <div className="min-h-screen bg-white pt-40 lg:pt-52 pb-20" data-id="element-910">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-911">
        {/* Page Header */}
        <div className="mb-12" data-id="element-912">
          <div className="flex items-center justify-center mb-6" data-id="element-913">
            <Video className="w-12 h-12 text-brand-purple-600 mr-4" data-id="element-914" />
            <h1 className="text-4xl font-bold text-gray-900" data-id="element-915">
              In-Person and Zoom Classes
            </h1>
          </div>
        </div>

        {/* Questions Section */}
        <div className="mb-12 bg-brand-purple-50 rounded-lg p-6 border-2 border-brand-purple-200 text-center" data-id="element-916">
          <h2 className="text-2xl font-bold text-brand-purple-900 mb-4" data-id="element-917">
            Questions?
          </h2>
          <div className="flex items-center justify-center text-lg" data-id="element-918">
            <Phone className="w-5 h-5 text-brand-purple-600 mr-2" data-id="element-919" />
            <span className="text-gray-700" data-id="element-920">Call or text to</span>
            <a href="tel:602-377-6207" className="ml-2 text-brand-purple-600 hover:text-brand-purple-700 font-bold" data-id="element-921">
              602-377-6207
            </a>
          </div>
        </div>

        {/* Testimonial */}
        <div className="mb-12 bg-white rounded-lg border-2 border-gray-200 p-8 shadow-sm" data-id="element-922">
          <div className="flex items-start mb-4" data-id="element-923">
            <MessageSquare className="w-8 h-8 text-brand-purple-600 mr-4 flex-shrink-0 mt-1" data-id="element-924" />
            <div data-id="element-925">
              <div className="flex items-center mb-3" data-id="element-926">
                <h3 className="text-lg font-bold text-gray-900 mr-2" data-id="element-927">
                  Testimonial from Kresta Davis, REALTOR®
                </h3>
                <div className="flex" data-id="element-928">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-yellow-400 fill-current" data-id="element-929" />)}
                </div>
              </div>
              <p className="text-base text-gray-700 leading-relaxed italic" data-id="element-930">
                "Jon, once again, one of the BEST classes! I can tell you are
                spending time making Zoom work for you because it genuinely was
                one of the best zoom classes I have taken. Most are difficult to
                even stay awake, even with the polls! In person AND on Zoom,
                your classes are THE BEST!"
              </p>
            </div>
          </div>
        </div>

        {/* Free Classes Notice */}
        <div className="mb-12 bg-green-50 border-l-4 border-green-400 p-6 rounded-lg" data-id="element-931">
          <p className="text-xl font-bold text-gray-900 text-center" data-id="element-932">
            ****Classes are FREE unless indicated otherwise****
          </p>
        </div>

        {/* Calendar Embed Placeholder */}
        <div className="bg-white rounded-lg border-2 border-gray-200 p-8" data-id="element-933">
          <div className="mb-6" data-id="element-934">
            <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-935">
              Class Schedule
            </h2>
          </div>

          {/* Example Calendar Image from Screenshot */}
          <div data-id="element-936">
            <img src="https://cdn.magicpatterns.com/uploads/3ZKpyqBfkEKB12J1Xpf28Z/image.png" alt="Class Schedule Calendar Example" className="w-full rounded-lg border border-gray-200" data-id="element-937" />
          </div>
        </div>

        {/* Additional Info */}
        <div className="mt-12 grid md:grid-cols-2 gap-6" data-id="element-938">
          <div className="bg-brand-purple-50 rounded-lg p-6 border border-brand-purple-100" data-id="element-939">
            <h3 className="text-xl font-bold text-brand-purple-900 mb-3" data-id="element-940">
              In-Person Classes
            </h3>
            <p className="text-base text-gray-700" data-id="element-941">
              Join us in person for engaging, interactive continuing education
              classes. Network with fellow real estate professionals while
              earning your CE credits.
            </p>
          </div>
          <div className="bg-blue-50 rounded-lg p-6 border border-blue-100" data-id="element-942">
            <h3 className="text-xl font-bold text-blue-900 mb-3" data-id="element-943">
              Zoom Classes
            </h3>
            <p className="text-base text-gray-700" data-id="element-944">
              Attend from anywhere with our interactive Zoom classes. Get the
              same quality instruction and engagement from the comfort of your
              home or office.
            </p>
          </div>
        </div>

        {/* Contact CTA */}
        <div className="mt-12 bg-brand-purple-50 rounded-lg p-8 text-center border border-brand-purple-100" data-id="element-945">
          <h2 className="text-2xl font-bold text-brand-purple-900 mb-4" data-id="element-946">
            Ready to Register?
          </h2>
          <p className="text-gray-700 mb-6" data-id="element-947">
            Have questions about upcoming classes or need help registering?
            We're here to help!
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-948">
            <a href="tel:602-377-6207" className="inline-flex items-center justify-center px-8 py-3 bg-brand-purple-600 text-white font-bold rounded-md hover:bg-brand-purple-700 transition-colors" data-id="element-949">
              <Phone className="w-5 h-5 mr-2" data-id="element-950" />
              Call 602-377-6207
            </a>
            <a href="/Contact" className="inline-flex items-center justify-center px-8 py-3 bg-white text-brand-purple-600 font-bold rounded-md border-2 border-brand-purple-600 hover:bg-brand-purple-50 transition-colors" data-id="element-951">
              Contact Us
            </a>
          </div>
        </div>
      </div>
    </div>;
}